import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import AOS from "aos";
import "aos/dist/aos.css";
import "animate.css";
import shape1 from "../assets/Images/shapes/lefttestimonialThread-01.png";
import shape2 from "../assets/Images/shapes/RightTestimonialThread-01.png";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import googleReviews from "../assets/Images/google-reviews.png";
import { Rating } from "@mui/material";
const testimonials = [
  {
    id: 1,
    name: "Jai Jaipal",
    role: "September 2025",
    star: 5,
    description:
      "Dr Amrish Ram Reddy sir general surgeon medical care given to the patient was good hospital was good staff Mod marketing person everyone are good n care taking thank you for everything",
  },
  {
    id: 2,
    name: "Laxmi Varthya",
    role: "September 2025",
    star: 5,
    description: `Dr. SWETHA MAM GENERAL MEDICINE is incredibly knowledgeable and took the time to answer all my questions. Highly recommend!"
Treatment was to good hospital staff was so help full in every situation
Managers also explaining well
Thank you team
`,
  },
  {
    id: 3,
    name: "Santosh Kumar Dash",
    role: "August 2025",
    star: 5,
    description: `Dr Mahendra sir pulmonogist.
He is really a great doctor. He advised proper treatment to my patient. I will recommend his name to all for any kind of allergy or lungs related issue.
Thank you Sir for your treatment and assistance
`,
  },
  {
    id: 4,
    name: "Sugadasu Munemma",
    role: "September 2025",
    star: 5,
    description: `Dr SINDHU MAM gynaecologist
Treatment was too good
I would like to thank you once again for the excellent care you provided me since few days after surgery., you have been very accomidating to my hectic schedule . Thanks so much for everything.”
And staff was explained everything very well and manager prashanth explained and guided too good and explained everything, regarding surgery and councelling Thank you team
`,
  },
  {
    id: 5,
    name: "Mutyala Koteswararao",
    role: "June 2025",
    star: 5,
    description: `Very nice hospitals we came here for emergency in a critical situation dr Pavan kumar sir he take care of us and finally we are happy now 😊`,
  },
  {
    id: 6,
    name: "Syed Asif Pasha",
    role: "August 2025",
    star: 5,
    description: `Dr ARJUN REDDY SIR PLASTIC SURGEON
Treatment is very well served treated very smoothly and advised also good Dr is very patience. Thank you so much Dr Arjun reddy
`,
  },
  {
    id: 7,
    name: "Rayudu Hari Krishna",
    role: "September 2025",
    star: 5,
    description:
      `DR AMRISH RAM REDDY GENERAL SURGEON
Treatment was good
Sir explained everything before surgery and after surgery
My father recovery was good
Complaired to before thank you sir
Must recommended hospital for any surgery cases
And compair to other hospitals cost was low
And staff,managers was too supportive
Thank you team
`,
  },
  {
    id: 8,
    name: "Brock Lesnar",
    role: "September 2025",
    star: 5,
    description: `Dr Swetha mam general physician.
Treatment is good and explained each n every point in details .very good behaviour by staff and doctors. Farooq and prashanth both MODs and pawan guided us in a very pleasant manner
`,
  },
  {
    id: 9,
    name: "Santosh Kumar Dash",
    role: "August 2025",
    star: 5,
    description: `Dr Mahendra sir pulmonogist.
He is really a great doctor. He advised proper treatment to my patient. I will recommend his name to all for any kind of allergy or lungs related issue
Thank you Sir for your treatment and assistance
`,
  },
  {
    id: 10,
    name: "Shivani Maddipatla",
    role: "August 2025",
    star: 5,
    description: `I was down with viral fever and visited the hospital, where I had the privilege of being treated by Dr. Mahendra, Pulmonologist.I sincerely appreciate his accurate diagnosis and effective treatment, and I am truly grateful for the care he provided
Thank you doctor for the treatment and care.
`,
  },

  {
    id: 11,
    name: "Mannu Yadav",
    role: "August 2025",
    star: 5,
    description: `My brother admitted in magnaid hospitals under Dr.swetha modem physician given good and well treated to my brother very well recovery from the date of admitted staff also very good and explained everything well services also good housekeeping staff were very helpful to us
`,
  },
  {
    id: 12,
    name: "Nagalakshmi Vadlamani",
    role: "July 2025",
    star: 5,
    description: `At MangAid hospital Dr Mahendra sir pulmonologist and Daibetologist Dr Swetha mam and other doctors are also very caring and polite. Hospital staff also so caring and immediate response for the patient`,
  },
];

export default function Testimonials() {
  const [index, setIndex] = useState(0);
  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

  const nextSlide = () => setIndex((index + 1) % testimonials.length);
  const prevSlide = () =>
    setIndex((index - 1 + testimonials.length) % testimonials.length);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileOrTablet(window.innerWidth < 1024); 
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div>
      <div className="overflow-hidden">
        <div className="max-w-[1340px] mx-auto px-[24px] md:px-[24px] xl:px-[0px]">
          <div className="relative">
            <div
              className="md:py-20 py-12 px-[12px] md:px-[80px] rounded-[24px] bg-[#c4e5e5]"
              style={
                !isMobileOrTablet
                  ? {
                    backgroundImage: `
                        url(${shape1}),
                        url(${shape2})
                      `,
                    backgroundPosition: "100% 100%, 0 56px",
                    backgroundRepeat: "no-repeat, no-repeat",
                    backgroundSize: "auto, auto",
                  }
                  : {}
              }
            >
              <div>
                <div className="flex justify-center items-center pb-10">
                  <img
                    src={googleReviews}
                    alt="google-revies"
                    className="sm:w-80 w-60"
                  />
                </div>
                <div className="flex justify-center" data-aos="fade-up">
                  <h2 className=" text-[36px] md:text-[58px] leading-[1.138em] font-heading text-thickGreen mb-[48px] text-center md:max-w-[768px]">
                    Hear from our Happy Patients
                  </h2>
                </div>
              </div>

              <div className="relative flex flex-col items-center justify-center">
               
                <div className="w-full max-w-2xl bg-white rounded-3xl shadow-lg p-10 text-center">
                  <AnimatePresence mode="wait">
                    <motion.div
                      key={testimonials[index].id}
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      transition={{ duration: 0.6 }}
                    >
                      <p className="text-paraGreen mb-6 font-body text-[15px] md:text-[20px]">
                        {testimonials[index].description}
                      </p>

               
                      <div className="flex items-center justify-center gap-4">
                        <AccountCircleIcon
                          sx={{
                            width: "50px",
                            height: "50px",
                          }}
                          className=" flex-shrink-0 rounded-full border-2 text-lightGreen border-lightGreen"
                        />
                        <div className="text-left">
                          <h4 className="text-lg font-medium text-thickGreen font-body">
                            {testimonials[index].name}
                          </h4>
                          <p>
                            <Rating
                              name="dynamic-rating"
                              value={testimonials[index].star || 0}
                              precision={0.5}
                              readOnly
                            />
                          </p>
                          <p className="text-sm text-paraGreen font-body">
                            {testimonials[index].role}
                          </p>
                        </div>
                      </div>
                    </motion.div>
                  </AnimatePresence>
                </div>

                {isMobileOrTablet ? (
                  <div className="flex gap-4 mt-6">
                    <button
                      aria-label="left"
                      onClick={prevSlide}
                      className="bg-white shadow-lg w-12 h-12 flex  font-medium  items-center justify-center rounded-full text-thickGreen hover:bg-thickGreen hover:text-white transition"
                    >
                      <FontAwesomeIcon icon={faChevronLeft} size="lg" />
                    </button>
                    <button
                      aria-label="right"
                      onClick={nextSlide}
                      className="bg-white shadow-lg w-12 h-12 flex  font-medium  items-center justify-center rounded-full text-thickGreen hover:bg-lightGreen transition"
                    >
                      <FontAwesomeIcon icon={faChevronRight} size="lg" />
                    </button>
                  </div>
                ) : (
                  <>
                
                    <button
                      aria-label="left"
                      onClick={prevSlide}
                      className="absolute left-10 bg-white shadow-lg w-12 h-12 flex font-medium  items-center justify-center rounded-full text-thickGreen hover:bg-thickGreen hover:text-white transition"
                    >
                      <FontAwesomeIcon icon={faChevronLeft} size="lg" />
                    </button>
                  
                    <button
                      aria-label="right"
                      onClick={nextSlide}
                      className="absolute right-10 bg-white shadow-lg w-12 h-12 font-medium  flex items-center justify-center rounded-full text-thickGreen hover:bg-lightGreen hover:text-white transition"
                    >
                      <FontAwesomeIcon icon={faChevronRight} size="lg" />
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
